'use client';

import { Children, useEffect, useState } from 'react';
import { TabbedNavigationHorizontal as DsmTabbedNavigationHorizontal } from '@kohler-dsm-library/kohler-modules';
import styles from './TabbedNavigation.module.css';

export default function TabbedNavigationWrapper({ mod, tabs = [], children }) {
  const panels = Children.toArray(children);
  const firstTabId = tabs[0]?.tabId || '';
  const [activeTab, setActiveTab] = useState(firstTabId);

  useEffect(() => {
    if (!tabs.length) {
      setActiveTab('');
      return;
    }

    if (!tabs.some((tab) => tab.tabId === activeTab)) {
      setActiveTab(firstTabId);
    }
  }, [activeTab, firstTabId, tabs]);

  if (!tabs.length) {
    return null;
  }

  return (
    <section className={`${mod}-mod ${styles.root}`}>
      <DsmTabbedNavigationHorizontal
        aria-label="Tabbed Navigation"
        align="center"
        className={styles.tabNavigation}
        tabs={tabs.map((tab) => ({
          id: tab.tabId,
          text: tab.label,
          'aria-controls': tab.panelId,
        }))}
        value={activeTab}
        onTabClick={setActiveTab}
      />
      {tabs.map((tab, index) => (
        <div
          key={tab.id}
          id={tab.panelId}
          role="tabpanel"
          aria-labelledby={tab.tabId}
          className={styles.panel}
          hidden={tab.tabId !== activeTab}
        >
          {panels[index] || null}
        </div>
      ))}
    </section>
  );
}
